export enum SaleType {
  WHOLESALE = 'WHOLESALE',
  RETAIL = 'RETAIL'
}
